// TODO: if lodash gets included in the future, replace this with _.range
export const range = (x: number) => [...Array(x).keys()];
